module.exports = __webpack_public_path__ + "img/uk-retail-3.a39fa3ad.png";